@if (errorService.serverError(); as serverError) {
	<error-page [status]="serverError" (logout)="logout()"></error-page>
} @else {
	<div
		class="app absolute top-0 w-full h-auto bottom-14.5 overflow-x-hidden overflow-y-auto lg:bottom-0 lg:overflow-hidden lg:relative lg:top-0 lg:mx-auto lg:my-0 lg:h-screen lg:max-w-480 before:block before:content-['']"
		[class]="pageName$ | async"
	>
		<div
			class="h-full min-h-full p-4 w-full lg:overflow-hidden lg:h-screen lg:border-solid lg:border-r lg:border-secondary-200 lg:max-w-480"
		>
			<app-shell-nav
				class="hide-mobile"
				[items]="desktopMenuPoints$ | async"
				[environment]="environment"
				[apps]="appNavMenuPoints$ | async"
				[activeApp]="activeApp"
				[currentUrl]="currentUrl$ | async"
				[navTranslations]="{
					beta: ('general.beta' | translate),
					apps: ('general.apps' | translate),
				}"
				(callbackEvent)="navCallback($event)"
			></app-shell-nav>
			<app-shell-mobile-nav
				class="hide-desktop"
				[items]="mobileMenuPoints$ | async"
				[environment]="environment"
				[apps]="appNavMenuPoints$ | async"
				[currentUrl]="currentUrl$ | async"
				(callbackEvent)="navCallback($event)"
				[navTranslations]="{
					beta: ('general.beta' | translate),
					apps: ('general.apps' | translate),
				}"
			></app-shell-mobile-nav>

			<div
				class="h-[calc(100vh-58px-2rem)] lg:absolute lg:top-0 lg:p-8 lg:left-17 lg:h-screen lg:w-[calc(100%-4.25rem)]"
				[class]="pageName$ | async"
			>
				<router-outlet></router-outlet>
				@if (error$ | async; as error) {
					<ui-overlay
						(closeOverlay)="onClose()"
						[showCloseButton]="true"
						[header]="error.type + '.header' | lowercase | translate"
					>
						<ui-error-content [error]="error" (closed)="onClose()"></ui-error-content>
					</ui-overlay>
				}
			</div>
		</div>
	</div>
	@if (helpOpen()) {
		<ui-overlay [header]="'help_overlay.title' | translate" (closeOverlay)="onCloseHelp()">
			<ui-help-content (closed)="onCloseHelp()"></ui-help-content>
		</ui-overlay>
	}
	<toast-container></toast-container>
	<cookie-overlay></cookie-overlay>
}
